import _default from './Search';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/semantic-ui-react/dist/es/modules/Search/index.js
// module id = 695
// module chunks = 0